import { useMutation, useQueryClient } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import { postJobActivityNote } from "src/api/Service/JobActivity"

import { useToast } from "src/hooks/use_toast"

const useAddJobNote = (jobId) => {
  const { marinaSlug } = useMarina()
  const showToast = useToast()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    ({ body }) => postJobActivityNote(marinaSlug, jobId, { body }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["jobActivity", marinaSlug, jobId])
        showToast("Note added", { type: "success" })
      },
      onError: (error) => {
        const message =
          error?.response?.data?.error ||
          error?.message ||
          "Could not add the note."
        showToast(message, { type: "error" })
      },
    }
  )

  return {
    addNote: (body, options = {}) => mutation.mutate({ body }, options),
    isAdding: mutation.isLoading,
  }
}

export default useAddJobNote
